import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { JwtHelper } from "./jwt";
import { Observable } from "rxjs";
import { Response, Headers, Http } from "@angular/http";
import { environment } from "../../../environments/environment";
import { Member } from "../member/member";

declare let window: any;

@Injectable()
export class AuthService implements CanActivate {
  jwtHelper: JwtHelper = new JwtHelper();

  tokenName: string = "heyground-token";
  accessToken: string = "access_token";
  refreshToken: string = "refresh_token";
  userName: string = "user_name"; // 유저 email
  authorities: string = "authorities"; // 유저 권한, admin/manager/user
  expDate: string = "exp_date"; // access token 만료 시간
  expDateRefreshToken: string = "exp_date_refresh"; // refresh token 만료 시간

  basicAuthetication = "aGV5Z3JvdW5kLXdlYjpmb28="; //btoa('heyground-web:foo');

  me: Member;

  constructor(private http: Http) {}

  saveToken(token: any) {
    localStorage.setItem(this.tokenName, JSON.stringify(token));
    localStorage.setItem(this.accessToken, token[this.accessToken]);
    localStorage.setItem(this.refreshToken, token[this.refreshToken]);

    let decodeToken = this.jwtHelper.decodeToken(token.access_token);
    localStorage.setItem(this.userName, decodeToken[this.userName]);
    localStorage.setItem(this.authorities, decodeToken[this.authorities]);

    let decodeRefreshToken = this.jwtHelper.decodeToken(token.refresh_token);

    let current: number = new Date().valueOf();
    let expiresIn: number = current + 1000 * token["expires_in"];
    let expiresInRefresh: number =
      current +
      1000 *
        (decodeRefreshToken["exp"] - decodeToken["exp"] + token["expires_in"]);

    localStorage.setItem(this.expDate, expiresIn.toString());
    localStorage.setItem(this.expDateRefreshToken, expiresInRefresh.toString());
  }

  removeToken() {
    localStorage.removeItem(this.tokenName);
    localStorage.removeItem(this.accessToken);
    localStorage.removeItem(this.refreshToken);
    localStorage.removeItem(this.userName);
    localStorage.removeItem(this.authorities);
    localStorage.removeItem(this.expDate);
    localStorage.removeItem(this.expDateRefreshToken);
  }

  getToken(): string {
    return localStorage.getItem(this.tokenName);
  }

  getAccessToken(): Observable<string> {
    let accessToken = localStorage.getItem(this.accessToken);

    if (accessToken) {
      if (new Date().valueOf() > +localStorage.getItem(this.expDate)) {
        return this.getRefreshToken(localStorage.getItem(this.refreshToken))
          .flatMap((token) => {
            this.saveToken(token);
            return Observable.of(token[this.accessToken]);
          })
          .catch((error) => {
            this.removeToken();
            return Observable.of("");
          });
      } else {
        return Observable.of(accessToken);
      }
    }
    return Observable.of("");
  }

  isExpiredRefreshToken(): boolean {
    return (
      new Date().valueOf() > +localStorage.getItem(this.expDateRefreshToken)
    );
  }

  getRefreshToken(token: string): Observable<Response> {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${this.basicAuthetication}`,
    });
    let body = `grant_type=refresh_token&refresh_token=${token}`;
    return this.http
      .post(environment.apiServer + "/oauth/token", body, { headers: headers })
      .map((res) => res.json());
  }

  canActivate(): boolean {
    return !!localStorage.getItem(this.userName);
  }

  getEmail(): string {
    return localStorage.getItem(this.userName);
  }

  getMe(): Member {
    return this.me;
  }

  hasManager(): boolean {
    return (
      ("" + localStorage.getItem(this.authorities)).indexOf("ROLE_MANAGER") !=
      -1
    );
  }

  isManager(): boolean {
    let authorities = "" + localStorage.getItem(this.authorities);
    return (
      authorities.indexOf("ROLE_ADMIN") == -1 &&
      authorities.indexOf("ROLE_MANAGER") != -1
    );
  }

  isAdmin(): boolean {
    return (
      ("" + localStorage.getItem(this.authorities)).indexOf("ROLE_ADMIN") !== -1
    );
  }

  /** for redirect */
  redirect: string = null;
  setRedirect(redirect) {
    this.redirect = redirect;
  }

  getPolicyStep(): String | undefined {
    return localStorage.getItem(`__hey_policy_${this.getEmail()}`);
  }

  setPolicyStep(step) {
    localStorage.setItem(`__hey_policy_${this.getEmail()}`, step);
  }

  static isValid(me: Member) {
    return (
      me.name &&
      me.name !== "" &&
      me.nick &&
      me.nick !== "" &&
      me.work &&
      me.work !== "" &&
      me.contact &&
      me.contact !== "" &&
      me.interest &&
      me.interest !== "" &&
      me.seatNo &&
      me.seatNo !== "" &&
      me.birthYear &&
      me.birthYear !== ""
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/auth/auth.service.ts